import { render, staticRenderFns } from "./AccountExpireNotice.vue?vue&type=template&id=30ba571a&scoped=true&"
import script from "./AccountExpireNotice.vue?vue&type=script&lang=js&"
export * from "./AccountExpireNotice.vue?vue&type=script&lang=js&"
import style0 from "./AccountExpireNotice.vue?vue&type=style&index=0&id=30ba571a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ba571a",
  null
  
)

export default component.exports